import React, { useState, useEffect } from 'react';
import { Target, Eye, Heart, TrendingUp, Mail, Phone, MapPin, ChevronLeft, ChevronRight, Award, BookOpen, Globe } from 'lucide-react';
import './About.css';

const About = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const totalSlides = 10;

  const images = [
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099553/IMG-20250801-WA0193_atvwcw.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099549/IMG-20250727-WA0005_gtgdxv.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099544/IMG-20250619-WA0094_ccvflt.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1766343171/WhatsApp_Image_2025-12-21_at_12.50.1_PM_xegocd.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099536/IMG-20250613-WA0004_he0sma.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099532/IMG-20250619-WA0091_dstd0d.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099529/IMG-20250613-WA0001_bwqltj.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099527/IMG-20250611-WA0018_ptf6sw.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099524/IMG-20250611-WA0017_yt4pme.jpg",
    "https://res.cloudinary.com/dcm2dsjov/image/upload/v1754099522/IMG-20250604-WA0122_aav721.jpg"
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex);
  };

  useEffect(() => {
    const imagePromises = images.map((src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = src;
      });
    });

    Promise.all(imagePromises)
      .then(() => setImagesLoaded(true))
      .catch((error) => console.error('Error loading images:', error));
  }, []);

  useEffect(() => {
    if (!imagesLoaded) return;
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [imagesLoaded]);



  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content fade-in-up">
          <span className="hero-badge">Conoce más sobre</span>
          <h1 className="about-title">VTIC</h1>
          <p className="hero-subtitle">
            Voluntariado de Educación e Investigación Científica de la UNAH.
            <br />Formando líderes, impulsando la ciencia.
          </p>
        </div>
      </div>

      <div className="about-container">
        {/* Mission & Vision Cards */}
        <div className="strategic-grid">
          <div className="strategic-card mission-card fade-in">
            <div className="card-icon-wrapper">
              <Target size={32} />
            </div>
            <h2>Misión</h2>
            <p>
              Impulsar la excelencia académica y el desarrollo científico a través
              de tutorías especializadas y grupos de investigación, formando profesionales
              comprometidos con el progreso de Honduras.
            </p>
          </div>

          <div className="strategic-card vision-card fade-in">
            <div className="card-icon-wrapper">
              <Eye size={32} />
            </div>
            <h2>Visión</h2>
            <p>
              Ser el referente nacional en educación complementaria e investigación estudiantil,
              reconocidos por la calidad de nuestros tutores y el impacto de nuestros proyectos
              científicos en la sociedad.
            </p>
          </div>
        </div>

        {/* Impact Stats */}
        <div className="impact-section fade-in">
          <div className="impact-header">
            <TrendingUp className="section-icon" size={28} />
            <h2>Nuestro Impacto</h2>
          </div>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">200+</span>
              <span className="stat-label">Estudiantes Beneficiados</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">8+</span>
              <span className="stat-label">Tutores Voluntarios</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">2</span>
              <span className="stat-label">Grupos de Investigación</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Compromiso</span>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="values-section fade-in">
          <div className="section-header-center">
            <Heart className="section-icon-center" size={28} />
            <h2>Nuestros Valores</h2>
            <div className="divider-center"></div>
          </div>
          <div className="values-grid">
            <div className="value-item">
              <Award size={24} className="value-icon-lucide" />
              <span>Excelencia Académica</span>
            </div>
            <div className="value-item">
              <BookOpen size={24} className="value-icon-lucide" />
              <span>Innovación Educativa</span>
            </div>
            <div className="value-item">
              <Heart size={24} className="value-icon-lucide" />
              <span>Trabajo Colaborativo</span>
            </div>
            <div className="value-item">
              <Globe size={24} className="value-icon-lucide" />
              <span>Responsabilidad Social</span>
            </div>
          </div>
        </div>



        {/* Timeline */}
        <div className="timeline-section fade-in">
          <div className="section-header-center">
            <h2>Nuestra Historia</h2>
            <div className="divider-center"></div>
          </div>
          <div className="timeline-container">
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-date">2024</div>
                <h3>Formalización</h3>
                <p>Establecimiento oficial de VTIC como voluntariado UNAH.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-date">2024</div>
                <h3>Investigación</h3>
                <p>Lanzamiento de los grupos pioneros GABEA y GIFA.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-date">2024</div>
                <h3>Expansión</h3>
                <p>Cobertura total en ciencias básicas: Física, Química, Biología y Matemáticas.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Gallery */}
        <div className="gallery-section fade-in">
          <div className="section-header-center">
            <h2>Galería de Actividades</h2>
            <div className="divider-center"></div>
          </div>
          <div className="carousel-container-modern">
            <div className="carousel-wrapper" style={{ display: imagesLoaded ? 'block' : 'none' }}>
              <div
                className="carousel-track"
                style={{ transform: `translateX(-${currentSlide * 10}%)` }}
              >
                {images.map((imageSrc, index) => (
                  <div key={index} className="carousel-slide">
                    <img src={imageSrc} alt={`Tutoría VTIC ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>
            {imagesLoaded && (
              <>
                <button className="carousel-btn prev-btn" onClick={prevSlide}><ChevronLeft size={24} /></button>
                <button className="carousel-btn next-btn" onClick={nextSlide}><ChevronRight size={24} /></button>
                <div className="carousel-indicators">
                  {Array.from({ length: totalSlides }, (_, index) => (
                    <span
                      key={index}
                      className={`indicator ${currentSlide === index ? 'active' : ''}`}
                      onClick={() => goToSlide(index)}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Contact */}
        <div className="contact-section-modern fade-in">
          <div className="contact-card">
            <h2>Contáctanos</h2>
            <p>Estamos listos para responder tus dudas y recibirte en nuestro equipo.</p>
            <div className="contact-methods">
              <div className="contact-method">
                <Mail className="contact-icon" size={24} />
                <span>vtic.unahcortes@gmail.com</span>
              </div>
              <div className="contact-method">
                <Phone className="contact-icon" size={24} />
                <span>+504 9777-3865</span>
              </div>
              <div className="contact-method">
                <MapPin className="contact-icon" size={24} />
                <span>UNAH, Cortés</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;